export class GetPeers {
  static readonly type = "[Peers] Get peers";
  constructor(public profileId?: string, public refreshRequest?: boolean) {}
}
